import { useState } from "react"
import { Paper, Typography, TextField, Button, Stack, Divider } from "@mui/material"
import SendIcon from "@mui/icons-material/Send"
import useError from "../../hooks/Error/useError"
import { useApiService } from "../../hooks/Api/useApiService"
import T from "../../hooks/Language/T"
import useTranslationSharie from "../../hooks/Language/useTranslation"

const ReflectPost = ({ wisdom, handleClose }) => {
  const [reflection, setReflection] = useState("")
  const { Error: AlertError, error, success } = useError()
  const { postData } = useApiService()
  const t = useTranslationSharie()

  const handleSubmit = async () => {
    if (reflection.length > 500) {
      error("Reflection is maximum 500 characters")
      return
    }
    if (!reflection.trim()) return
    try {
      const user_name = localStorage.getItem("user")
      const data = await postData("skills/postreflection", {
        reflection: reflection.trim(),
        wisdom,
        user_name,
      })
      if (data?.message === "Successful") {
        success("Post Added Successfully")
        setReflection("")
      } else {
        error(data?.message ?? "Failed to post reflection")
      }
    } catch (err) {
      error(err.message ?? "Network error while posting reflection")
    }
    setTimeout(() => {
      handleClose()
    }, 2500)
  }

  return (
    <T>
      <Paper
        elevation={8}
        sx={{
          p: 3,
          maxWidth: 500,
          width: "90%",
          bgcolor: "text.primary",
          borderRadius: 3,
          border: "2px solid #1976d2",
        }}
      >
        <Stack spacing={2}>
          <Typography variant='h6' color='#1976d2' fontWeight='bold'>
            🪐 {t("Reflect on Today's Wisdom")}
          </Typography>
          <Typography variant='body1' color='purple'>
            "{wisdom?.quote ?? "No wisdom available today."}"
          </Typography>
          {wisdom?.question && (
            <Typography variant='body2' color='textSecondary'>
              {wisdom.question}
            </Typography>
          )}
          <Divider />
          <TextField
            multiline
            minRows={4}
            maxRows={10}
            fullWidth
            aria-label='Reflection input'
            placeholder={t("What does this mean to you today?")}
            value={reflection}
            onChange={(e) => setReflection(e.target.value)}
            variant='outlined'
          />
          <Button
            variant='contained'
            color='primary'
            onClick={handleSubmit}
            endIcon={<SendIcon />}
            disabled={!reflection.trim()}
            sx={{
              alignSelf: "flex-end",
              bgcolor: "#1976d2",
              ":hover": { bgcolor: "#115293" },
            }}
          >
            Post Reflection
          </Button>
          <AlertError />
        </Stack>
      </Paper>
    </T>
  )
}

export default ReflectPost
